import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=2bddb750&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=2bddb750&prod&lang=css"
import style1 from "./Settings.vue?vue&type=style&index=1&id=2bddb750&prod&scoped=true&lang=css"
import style2 from "./Settings.vue?vue&type=style&index=2&id=2bddb750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bddb750",
  null
  
)

export default component.exports